module.exports = __webpack_public_path__ + "static/media/DSC_0265.53fa8834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0265.jpg
// module id = 657
// module chunks = 0